// Small rules about categories, shared by Settings and the edit panel's "+ New" chip.

import { PALETTE_KEYS, type Category, type PaletteKey } from '@/types'

/** The least-used colour among the categories in use, so a new one stands apart; c1 first on a tie. */
export function nextColor(categories: Pick<Category, 'color' | 'archived'>[]): PaletteKey {
  const used = new Map<PaletteKey, number>()
  for (const c of categories) if (!c.archived) used.set(c.color, (used.get(c.color) ?? 0) + 1)
  let best: PaletteKey = 'c1'
  let min = Infinity
  for (const k of PALETTE_KEYS) {
    const n = used.get(k) ?? 0
    if (n < min) {
      min = n
      best = k
    }
  }
  return best
}

/** An existing category in use with this name, ignoring case and spaces at the ends, so "garden" picks "Garden". */
export function findByName<T extends Pick<Category, 'name' | 'archived'>>(categories: T[], name: string): T | undefined {
  const wanted = name.trim().toLowerCase()
  return categories.find((c) => !c.archived && c.name.trim().toLowerCase() === wanted)
}
